import React, { useState, useEffect } from 'react';
import _, { lastIndexOf } from 'lodash';
import 'draft-js/dist/Draft.css';

import { Box, Typography, FormHelperText, Tooltip } from '@mui/material';

import useGlobalStatus from '../../../hook/useGlobalStatus';

import LineFieldsTarget from './LineFieldsTarget';
import LineFieldsAllMetric from './LineFieldsAllMetric';
import LineFieldsCustomConvertions from './LineFieldsCustomConvertions';
import LineFieldsSelected from './LineFieldsSelected';

import { generalData } from '../../../utils/LineFieldsDefined';

import { CustomFormLabel, BoxBorderGrey } from '../../customComponent';
import { PagesOutlinedIcon, HelpOutlineIcon } from '../../../constants/images';
import theme from '../../../theme';


const LineFieldsData = (props) => {
  const {
    selectedAdAccounts,
    handleModalDetail,
    changeDefinedFields,
    inputErrorMsg,
    downloadInputErrorMsg,
    handleDeleteFields,
    currentSheetName,
    setCurrentSheetName,
    setCurrentSheetOrigiName,
    selectedExcelIndex,
    setSelectedExcelIndex,
    allDisplayFields,
    currentSheetSelectFields,
    setCurrentSheetSelectFields,
    currenOptionFields,
    setCurrenOptionFields,
    selectedGeneralFields,
    setSelectedGeneralFields,
    setOrigiCustomData,
    selectedCustomFields,
    setSelectedCustomFields,
    customFieldsData,
    campaignGoalsSelected,
    updateSortFields,
    setUpdateSortFields,
    changeCampaignGoals,
    campaignGoalsList,
    setModalName,
    scrollToAnchor,
    setIsLoading,
    loadingBox
  } = props;

  const { currentActiveData, setCurrentActiveData, entryPath, setEntryPath } = useGlobalStatus();
  const [searchKeyword, setSearchKeyword] = useState("");

  //預設選擇欄位
  useEffect(() => {
    if (entryPath.includes('create')) {
      setSelectedGeneralFields(generalData);
    }
  }, [entryPath])

  useEffect(() => {
    if (entryPath.includes('edit')) {
      const filterGeneralFields = currentActiveData.fields.filter((el) => el.cid === null);
      setSelectedGeneralFields(filterGeneralFields);
    }
  }, [entryPath, currentActiveData])

  //排序欄位
  const handleUpdateSortFields = (sortFields) => {
    if (!sortFields || sortFields.length === 0) return;
    setCurrentSheetName('');

    const updateGeneralField = updateFields(selectedGeneralFields, sortFields);
    const updateCustomFields = updateFields(selectedCustomFields, sortFields);

    setSelectedGeneralFields(updateGeneralField);
    setSelectedCustomFields(updateCustomFields);
  }

  const updateFields = (origiFields, sortFields) => {
    return origiFields.map((field) => {
      const matchField = _.find(sortFields, { expression: field.expression });
      if (matchField) {
        return { ...field, indexNumber: matchField.indexNumber };
      } else {
        return { ...field, indexNumber: null };
      }
    })
  }

  return (
    <Box mb={5}>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <PagesOutlinedIcon sx={{ mr: 0.5, verticalAlign: 'sub' }} />
        設定廣告目標與欄位指標
      </Typography>

      <Box mb={0}>
        <CustomFormLabel>廣告目標與欄位指標<span>*</span>
          <Tooltip title="每一廣告目標匯出一份報表，點擊廣告目標可於右方設定各廣告目標報表需匯出的欄位指標。" placement="bottom-start">
            <HelpOutlineIcon variant="dark" />
          </Tooltip>
        </CustomFormLabel>

        <BoxBorderGrey
          sx={{
            flexGrow: 1,
            display: 'flex',
            padding: 0,
            mb: 0
          }}
        >
          <LineFieldsTarget
            selectedAdAccounts={selectedAdAccounts}
            setCurrentSheetName={setCurrentSheetName}
            setCurrentSheetOrigiName={setCurrentSheetOrigiName}
            selectedExcelIndex={selectedExcelIndex}
            setSelectedExcelIndex={setSelectedExcelIndex}
            setCurrentSheetSelectFields={setCurrentSheetSelectFields}
            selectedGeneralFields={selectedGeneralFields}
            selectedCustomFields={selectedCustomFields}
            campaignGoalsSelected={campaignGoalsSelected}
            changeCampaignGoals={changeCampaignGoals}
            campaignGoalsList={campaignGoalsList}
            loadingBox={loadingBox}
            setSearchKeyword={setSearchKeyword}
          />

          <Box sx={{ flex: 3.2 }}>
            <LineFieldsCustomConvertions {...props} />

            <Box
              sx={{
                flex: 3.2,
                display: 'flex',
                padding: 0,
                mb: 0
              }}
            >
              <LineFieldsAllMetric
                handleModalDetail={handleModalDetail}
                changeDefinedFields={changeDefinedFields}
                currentSheetName={currentSheetName}
                allDisplayFields={allDisplayFields}
                currentSheetSelectFields={currentSheetSelectFields}
                setCurrentSheetSelectFields={setCurrentSheetSelectFields}
                selectedGeneralFields={selectedGeneralFields}
                setSelectedGeneralFields={setSelectedGeneralFields}
                selectedCustomFields={selectedCustomFields}
                campaignGoalsList={campaignGoalsList}
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                handleDeleteFields={handleDeleteFields}
              />

              <LineFieldsSelected
                allfields={_.concat(selectedGeneralFields, selectedCustomFields)}
                handleDeleteFields={handleDeleteFields}
                currentSheetName={currentSheetName}
                allDisplayFields={allDisplayFields}
                currentSheetSelectFields={currentSheetSelectFields}
                setCurrentSheetSelectFields={setCurrentSheetSelectFields}
                currenOptionFields={currenOptionFields}
                setCurrenOptionFields={setCurrenOptionFields}
                setSelectedGeneralFields={setSelectedGeneralFields}
                setSelectedCustomFields={setSelectedCustomFields}
                updateSortFields={updateSortFields}
                setUpdateSortFields={setUpdateSortFields}
                campaignGoalsList={campaignGoalsList}
                handleUpdateSortFields={handleUpdateSortFields}
              />

            </Box>
          </Box>

        </BoxBorderGrey>
        {
          <>
            <FormHelperText error>
              {inputErrorMsg.optionFieldName}
            </FormHelperText>
            <FormHelperText error>
              {inputErrorMsg.campaignGoalsSelected}
            </FormHelperText>
          </>
        }
      </Box>
    </Box>
  )
}

export default LineFieldsData;